export enum ActionType {
  ShowSidebar,
}

export interface ShowSidebar {
  type: ActionType.ShowSidebar;
}

export type SidebarAction = ShowSidebar;
